<app-card [headerTitle]="'Inverse Table Background'" [border]="true" [padding]="false" [cardClass]="'common-striped'">
	<p class="f-m-light mt-1" header5></p>
	<div class="table-responsive custom-scrollbar">
		<table class="table table-striped">
			<thead class="tbl-strip-thad-bdr">
				<tr>
					<th scope="col">Id</th>
					<th scope="col">First Name</th>
					<th scope="col">Last Name</th>
					<th scope="col">Company</th>
					<th scope="col">Credit Volume</th>
					<th scope="col">Username</th>
					<th scope="col">Role</th>
					<th scope="col">Country</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let details of inverseTableBackground; trackBy: trackByDetails">
					<th scope="row">{{ details.id }}</th>
					<td>{{ details.first_name }}</td>
					<td>{{ details.last_name }}</td>
					<td>{{ details.company }}</td>
					<td>{{ details.credit_volume }}</td>
					<td>{{ details.user_name }}</td>
					<td>{{ details.role }}</td>
					<td>{{ details.country }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</app-card>
